<template lang="pug">
b-table.table-outline.mb-0(hover, responsive, outline, head-variant='default', :items='data', :fields='label', :small='small', @row-clicked='ping', :sort-by.sync="sortBy", :sort-desc.sync="sortDesc")
  template(slot='avatar' scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url || "static/img/avatars/0.png"', alt='', v-b-tooltip.hover='userIdString(item.value.tooltip)', v-if='item.value.tooltip')
      span.avatar-status(:class='item.value.status ? "bg-" + item.value.status : "bg-danger"', v-if='item.value.status')
      span.avatar-platform.fa(:class='[item.value.platform == "fb" && "fa-facebook-official", item.value.platform == "whatsapp" && "fa-whatsapp", item.value.platform != "whatsapp" && item.value.platform != "fb" && "fa-globe"]', v-if='item.value.platform')
  template(slot='messageId', scope='item')
    | {{item.value}}
  template(slot='message', scope='item')
    div {{item.value}}
  template(slot='flagHandleBy', scope='item')
    b-form(inline, @click.stop='', @submit.prevent='')
      b-input-group
        b-form-input.table-flaghandle(:value='item.value.flagHandleBy[0]', readonly)
        b-input-group-button(slot='right')
          b-btn(variant='outline-primary', :id='"flagHandleBy" + item.value.id')
            i.fa.fa-caret-left
    b-popover(:target='"flagHandleBy" + item.value.id', placement='left', triggers='click', ref='popover')
      | {{item.value.flagHandleByString}}
  template(slot='firstInteraction', scope='item')
    span(v-if='item.value!=null&&item.value!=""&&item.value!="-"') {{item.value | moment('from', 'now')}}
    span(v-else) Invalid Date
  template(slot='numTimestamp', scope='item')
    span(v-if='item.value!=null&&item.value!=""&&item.value!="-"') {{item.value | moment('from', 'now')}}
    span(v-else) Invalid Date
  template(slot='agent' scope='item')
    div.avatar
      img.img-avatar(:src='item.value.url', alt='', v-b-tooltip.hover.right='userIdString(item.value.tooltip)')
  template(slot='sentiment' scope='item')
    button.btn.btn-success(v-if="item.value && item.value.number >= 0")
      | {{item.value.score}} &nbsp;
      span.fa.fa-thumbs-o-up
    button.btn.btn-danger(v-else-if="item.value && item.value.number < 0")
      | {{item.value.score}} &nbsp;
      span.fa.fa-thumbs-o-down
    button.btn.btn-secondary(v-else)
      | -
</template>
<script>
// import moment from 'moment'

export default {
  name: 'app-interactionsTable',
  data: function() {
    return {
      messageModel: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      sortDesc: true,
      sortBy: null,
    }
  },
  props: {
    small: false,
    rowClick: false,
    rowBroadcastClick: false,
    sending: false,
    data: {
      type: Array,
      default: () => [],
    },
    label: {
      type: Object,
      default: () => {
        return {
          avatar: {
            label: '<i class="icon-people"></i>',
            class: 'text-center',
          },
          user: {
            label: 'User',
          },
          country: {
            label: 'Country',
            class: 'text-center',
          },
          usage: {
            label: 'Usage',
          },
          payment: {
            label: 'Payment method',
            class: 'text-center',
          },
          activity: {
            label: 'Activity',
          },
          actions: {
            label: '',
            thStyle: {
              minWidth: '14em',
            },
          },
        }
      },
    },
  },
  methods: {
    focus(id) {
      setTimeout(function() {
        document.getElementById('input' + id).focus()
      }, 100)
    },
    ping (e) {
      if (this.rowClick) {
        let routeData = this.$router.resolve({ name: 'Interaction', params: { userId: e.userId } })
        window.open(routeData.href, '_blank')
      }
      // this.rowClick && this.$router.push({ name: 'Interaction', params: { userId: e.userId } })
      // this.rowBroadcastClick && this.$router.push({ name: 'Broadcast', params: { Id: e.broadcastActions } })
    },
    chatLink (value) {
      return { name: 'Interaction', params: { userId: value } }
    },
    userIdString (value) {
      return value ? value.toString() : ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/InteractionsTable.vue?b7609c68